<template>
  <div class="table-box">
    <div class>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="contractTemplateName"
          label="合同名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="jiafang"
          label="需求方"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="yifang"
          label="服务提供方"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="平台服务费（算法）"
        >
          <template>
            项目当月收入×1.0675x平台服务费率
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="签约状态"
        >
          <template slot-scope="scope">
            {{ scope.row.status | transSign }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="sign(scope.row)"
              v-if="scope.row.status != 2"
            >
              签约
            </el-button>
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.status != 2"
              @click="goContractInfo2(scope.row)"
            >
              查看合同
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="download(scope.row, 3)"
              :disabled="scope.row.status != 2"
            >
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- ‘如何查看合同签名信息’按钮 -->
    <ContractSignatureView></ContractSignatureView>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import { pageInation } from '@/Mixin/listMixin';
import { eContract, platformContractList } from '@/api/ajax';
import OpenNewWin from '@/tools/openNewWin';
import ContractSignatureView from '@/components/contractSignatureView';
import { checkV3NoSigned } from '../../methods/check';

export default {
  mixins: [pageInation],
  components: { ContractSignatureView },
  data() {
    return {
      tableData: [],
      // getList: eContract.xrkContractList,
      getList: platformContractList,
      signFlag: true
    };
  },
  filters: {
    transSign(v) {
      if (v == 0 || !v) {
        return '未签约';
      } else if (v == 1) {
        return '签约中';
      } else if (v == 2) {
        return '已完成';
      } else {
        return '签约失败';
      }
    }
  },
  methods: {
    ...mapMutations(['INIT_PROJECT_STATE']),
    async sign(row) {
      await checkV3NoSigned();
      if (this.signFlag) {
        this.signFlag = false;
        let win = new OpenNewWin();
        win.createWin();
        try {
          let {
            pdata: { signUrl }
          } = await eContract.signingPlatformContract({
            signingId: row.signingId,
            redirectUrl: location.href + '?close=1'
          });
          win.setUrl(signUrl);
          this.checkIfSign();
          this.signFlag = true;
        } catch (e) {
          this.signFlag = true;
        }
      }

      // await eContract.signingPlatformContract({
      //   signingId: row.signingId,
      //   redirectUrl: location.href
      // })
      // this.initWatchRouteChange()
    },
    download(row, type) {
      if (type == 1 && (row.projectType == 7 || row.projectType == 8)) {
        type = 0;
      }
      const ajax = [
        'firstYshSignDownloadUrl2',
        'firstSignDownloadUrl2',
        'lookCsoGysContractDownloadUrl2',
        'lookXrkContractDownloadUrl2'
      ];
      this.$downloadFile(
        `${eContract[ajax[type]]}?id=${row.id}&signingId=${row.signingId}`,
        true
      );
    },
    goContractInfo2(row) {
      let win = new OpenNewWin();
      win.createWin();
      eContract.lookXrkContract({ id: row.id }).then(res => {
        win.setUrl(res.data.data);
      });
    }
  },
  mounted() {
    this.INIT_PROJECT_STATE();
  },
  created() {
    // TODO: 暂时这样处理，E签宝回调后关闭页面
    if (this.$route.query.close) {
      window.close();
    }
  }
};
</script>
<style lang="scss" scoped></style>
